module.exports = __webpack_public_path__ + "static/media/94AB46B0-8BC0-4A5C-B39F-55B359A86DAC.9fd0ec47.png";